import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { ISearchBoxProps } from './ISearchBoxProps';

/** Пауза введення перед пошуком (мс): список не перезапитується на кожну літеру. */
const DELAY = 250;

/**
 * Пошук панелі списку (UIUX tables/toolbar; прототип v4 L694): «Шукати за назвою або ID», 220px; введене застосовується після паузи 250 мс
 * (і одразу — за Enter), зовнішня зміна (скидання фільтрів, інший пункт меню) оновлює поле.
 */
export function SearchBox({ value, onChange }: ISearchBoxProps) {
  const { t } = useTranslation();
  const [text, setText] = useState(value);
  const sent = useRef(value);
  const timer = useRef<number | undefined>(undefined);
  useEffect(() => {
    if (value !== sent.current) { sent.current = value; setText(value); }
  }, [value]);
  useEffect(() => () => window.clearTimeout(timer.current), []);
  const apply = (next: string) => {
    window.clearTimeout(timer.current);
    if (next === sent.current) return;
    sent.current = next;
    onChange(next);
  };
  const change = (next: string) => {
    setText(next);
    window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => apply(next), DELAY);
  };
  return (
    <input className="lv-search" type="search" value={text} placeholder={t('listbar.search')} aria-label={t('listbar.search')}
      onChange={(e) => change(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') apply(text); }} />
  );
}
